export enum DeflectionLimit {
    l300 = "l/300",
    l500 = "l/500",
    OTHER = "Other"
}